import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import FeedbackQuery from './FeedbackQuery';

const FeedbackConnectorApollo = ({ children }) => {
  const { loading, error, data } = useQuery(FeedbackQuery, {
    fetchPolicy: 'no-cache',
  });

  const result = {
    loading,
    error,
    feedback: {},
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.feedback = { ...data.integration.feedback };
  }

  return children(result);
};

FeedbackConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default FeedbackConnectorApollo;
